import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  return {
    sessionItemResult: _objectSpread({
      padding: componentTheme.sessionItemResultPadding
    }, props.shouldRenderTopBorder && {
      borderTop: "solid ".concat(componentTheme.topBorderWidth, " ").concat(componentTheme.topBorderColor)
    }),
    result: {
      margin: componentTheme.resultMargin
    },
    points: {
      color: componentTheme.pointsColor,
      fontSize: componentTheme.pointFontSize
    },
    question: {
      fontSize: componentTheme.questionFontSize
    },
    sessionItemResultHeader: {
      display: 'flex',
      alignItems: 'center'
    },
    itemFeedbackWrapper: {
      marginTop: componentTheme.itemFeedbackWrapperMargin,
      padding: componentTheme.itemFeedbackWrapperPadding,
      borderRadius: componentTheme.itemFeedbackWrapperBorderRadius,
      fontSize: componentTheme.itemFeedbackWrapperFontSize,
      whiteSpace: 'pre-wrap',
      borderStyle: componentTheme.itemFeedbackWrapperStyle,
      borderWidth: componentTheme.itemFeedbackWrapperBorderWidth,
      borderColor: componentTheme.itemFeedbackWrapperBorderColor
    },
    textPadding: {
      paddingLeft: componentTheme.textPaddingLeft,
      paddingBottom: componentTheme.textPaddingBottom
    },
    itemFeedbackLabel: {
      color: componentTheme.itemFeedbackLabelColor,
      fontSize: componentTheme.itemFeedbackLabelFontSize,
      marginBottom: componentTheme.itemFeedbackMargin
    },
    itemFeedbackText: {
      marginTop: componentTheme.itemFeedbackTextMargin,
      fontSize: componentTheme.itemFeedbackTextSize
    }
  };
};
export default generateStyle;